import { render, staticRenderFns } from "./header_submenu.vue?vue&type=template&id=446c2cfc&"
import script from "./header_submenu.vue?vue&type=script&lang=js&"
export * from "./header_submenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports